import { render, staticRenderFns } from "./transfer-report.vue?vue&type=template&id=0ba40696"
import script from "./transfer-report.vue?vue&type=script&lang=js"
export * from "./transfer-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports